import GetStartedBox from "./GetStartedBox";

export default GetStartedBox;

export type { GetStartedBoxProps } from "./GetStartedBox";
